export default {
    name: 'InputButton',

    props: {
        title: String,
        type: String
    }
}